import { makeStyles, shorthands } from '@fluentui/react-components';

export const useGenerateButtonStyles = makeStyles({
  generateButton: {
    marginTop: '12px',
    width: '100%',
    color: 'white',
    fontSize: '16px',
    lineHeight: '22px',
    borderRadius: '4px',
    ...shorthands.padding('9px', '0px'),
    background: 'linear-gradient(90.5deg, #185ABD 0%, #8763C2 100%) !important',
    flexShrink: 0,
  },
  disabledGenerateButton: {
    background: 'rgba(240, 240, 240, 1)',
    color: 'rgba(189, 189, 189, 1)',
  },
});
